import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Instagram, Youtube, Linkedin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-alden-green-dark to-alden-green text-white">
      {/* Main Footer Content */}
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_turnkey-plants-1/artifacts/betwu2y9_ALDEN%20LOGO%20PNG.png" 
              alt="Alden Technologies" 
              className="h-16 mb-4 brightness-0 invert"
            />
            <p className="text-white/90 mb-4 leading-relaxed">
              India's trusted manufacturer of complete turnkey mineral water bottling plants with 100+ successful installations.
            </p>
            <div className="flex gap-3">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-all">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-all">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-all">
                <Youtube className="w-5 h-5" />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-all">
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Products */}
          <div>
            <h3 className="text-xl font-bold mb-4">Products</h3>
            <ul className="space-y-2">
              <li><Link to="/products/60-bpm-water-filling-machine" className="text-white/80 hover:text-yellow-300 transition-colors">Water Filling Machines</Link></li>
              <li><Link to="/products/5000-lph-ro-plant" className="text-white/80 hover:text-yellow-300 transition-colors">RO Water Plants</Link></li>
              <li><Link to="/products/pet-bottle-blowing-machine" className="text-white/80 hover:text-yellow-300 transition-colors">PET Bottle Blowing</Link></li>
              <li><Link to="/products/sticker-labelling-machine" className="text-white/80 hover:text-yellow-300 transition-colors">Labelling Machines</Link></li>
              <li><Link to="/products/shrink-packaging-machine" className="text-white/80 hover:text-yellow-300 transition-colors">Shrink Packaging</Link></li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-white/80 hover:text-yellow-300 transition-colors">Home</Link></li>
              <li><Link to="/about-us" className="text-white/80 hover:text-yellow-300 transition-colors">About Us</Link></li>
              <li><Link to="/manufacturing-facility" className="text-white/80 hover:text-yellow-300 transition-colors">Manufacturing</Link></li>
              <li><Link to="/installation-gallery" className="text-white/80 hover:text-yellow-300 transition-colors">Projects</Link></li>
              <li><Link to="/blog" className="text-white/80 hover:text-yellow-300 transition-colors">Blog</Link></li>
              <li><Link to="/downloads" className="text-white/80 hover:text-yellow-300 transition-colors">Downloads</Link></li>
              <li><Link to="/careers" className="text-white/80 hover:text-yellow-300 transition-colors">Careers</Link></li>
              <li><Link to="/contact" className="text-white/80 hover:text-yellow-300 transition-colors">Contact</Link></li>
            </ul>
          </div>

          {/* Support & Contact */}
          <div>
            <h3 className="text-xl font-bold mb-4">Support</h3>
            <ul className="space-y-2 mb-6">
              <li><Link to="/after-sales-service" className="text-white/80 hover:text-yellow-300 transition-colors">After Sales Service</Link></li>
              <li><Link to="/amc-services" className="text-white/80 hover:text-yellow-300 transition-colors">AMC Services</Link></li>
              <li><Link to="/faq" className="text-white/80 hover:text-yellow-300 transition-colors">FAQs</Link></li>
              <li><Link to="/privacy-policy" className="text-white/80 hover:text-yellow-300 transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms-conditions" className="text-white/80 hover:text-yellow-300 transition-colors">Terms & Conditions</Link></li>
            </ul>

            <div className="space-y-3">
              <a href="tel:+919351292512" className="flex items-center gap-2 text-white/90 hover:text-yellow-300 transition-colors">
                <Phone className="w-4 h-4 flex-shrink-0" />
                <span className="text-sm">+91 93512 92512</span>
              </a>
              <a href="tel:+919351002512" className="flex items-center gap-2 text-white/90 hover:text-yellow-300 transition-colors">
                <Phone className="w-4 h-4 flex-shrink-0" />
                <span className="text-sm">+91 93510 02512</span>
              </a>
              <a href="mailto:info@aldentechnologies.in" className="flex items-start gap-2 text-white/90 hover:text-yellow-300 transition-colors">
                <Mail className="w-4 h-4 flex-shrink-0 mt-0.5" />
                <span className="text-sm break-all">info@aldentechnologies.in</span>
              </a>
              <a href="mailto:aldentechnologiesindia@gmail.com" className="flex items-start gap-2 text-white/70 hover:text-yellow-300 transition-colors">
                <Mail className="w-4 h-4 flex-shrink-0 mt-0.5" />
                <span className="text-sm break-all">aldentechnologiesindia@gmail.com</span>
              </a>
            </div>
          </div>
        </div>

        {/* Address & Map */}
        <div className="grid md:grid-cols-2 gap-8 mt-12 pt-8 border-t border-white/20">
          <div>
            <h3 className="text-xl font-bold mb-4 flex items-center gap-2">
              <MapPin className="w-5 h-5" />
              Our Location
            </h3>
            <p className="text-white/90 leading-relaxed mb-4">
              Khasra No. 588, Machara Harmada,<br />
              Jaipur, Rajasthan – 302013<br />
              India
            </p>
            <div className="flex flex-wrap gap-3">
              <a href="https://wa.me/919351292512" target="_blank" rel="noopener noreferrer" className="bg-green-500 hover:bg-green-600 text-white px-6 py-2 rounded-lg font-semibold transition-all">
                WhatsApp
              </a>
              <a href="tel:+919351292512" className="bg-alden-navy hover:bg-alden-navy-light text-white px-6 py-2 rounded-lg font-semibold transition-all">
                Call Now
              </a>
            </div>
          </div>
          <div className="h-64 rounded-lg overflow-hidden">
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3558.7108447797596!2d75.78537631504288!3d26.885129983142677!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x396db5e3e3e3e3e3%3A0x3e3e3e3e3e3e3e3e!2sJaipur%2C%20Rajasthan!5e0!3m2!1sen!2sin!4v1234567890123!5m2!1sen!2sin"
              width="100%" 
              height="100%" 
              style={{ border: 0 }}
              allowFullScreen="" 
              loading="lazy"
              title="Alden Technologies Location"
            ></iframe>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="bg-alden-green-dark py-4">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-white/80">
            <p>© {currentYear} Alden Technologies. All rights reserved.</p>
            <p>Made in India with ❤️ for Excellence</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
